export const IconChevronUp = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M4.793 15.457a1 1 0 0 0 1.414 0L12 9.664l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 8.25a2 2 0 0 0-2.828 0l-5.793 5.793a1 1 0 0 0 0 1.414"
        clipRule="evenodd"
      />
    </svg>
  );
};
